module.exports = "https://cdn.zapier.com/blog/d5243069571f03e9d29781d99557774902231274/_next/static/images/green-09739247ae782ed1306737140440699c.png";